module.exports = __webpack_public_path__ + "img/logo-primary.7a2cc1e8.png";